/** Format a 0x hash or address as compact text. */
export function formatHash(value: string, options: formatHash.Options = {}): string {
  const { end = 4, start = 6 } = options
  if (value.length <= start + end) return value
  return `${value.slice(0, start)}…${value.slice(-end)}`
}

export declare namespace formatHash {
  /** Options for {@link formatHash}. */
  type Options = {
    /** Number of leading characters to keep. @default 6 */
    start?: number | undefined
    /** Number of trailing characters to keep. @default 4 */
    end?: number | undefined
  }
}
